module.exports = __webpack_public_path__ + "img/img3.55c21de9.png";